// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disputes-all {
  grid-template-columns: repeat(5, auto);
}
.disputes-resolved {
  grid-template-columns: repeat(8, auto);
}
.dispute-action {
  color: #5484ff;
  cursor: pointer;
  margin: 0 3px;
  font-size: 16px;
  transition: color 0.2s ease;
}
.dispute-action:hover {
  color: #3366cc;
}
`, "",{"version":3,"sources":["webpack://./src/app/dispute-tracker/dispute-list/dispute-list.component.less"],"names":[],"mappings":"AAAA;EACI,sCAAA;AACJ;AAEA;EACI,sCAAA;AAAJ;AAGA;EACI,cAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,2BAAA;AADJ;AAGI;EACI,cAAA;AADR","sourcesContent":[".disputes-all {\n    grid-template-columns: repeat(5, auto);\n}\n\n.disputes-resolved {\n    grid-template-columns: repeat(8, auto);\n}\n\n.dispute-action {\n    color: #5484ff;\n    cursor: pointer;\n    margin: 0 3px;\n    font-size: 16px;\n    transition: color 0.2s ease;\n    \n    &:hover {\n        color: #3366cc;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
